import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ObterArquivoCadernoPorIdState } from '../../reducers/Caderno/obter-arquivo-caderno-por-id.reducer';

export const selectObterArquivoCadernoPorIdState = createFeatureSelector<ObterArquivoCadernoPorIdState>('obterArquivoCadernoPorId');

export const selectDadosObterArquivoCadernoPorId = createSelector(
    selectObterArquivoCadernoPorIdState,
    (state: ObterArquivoCadernoPorIdState) => state.response
);

export const selectObterArquivoCadernoPorId = createSelector(
  selectObterArquivoCadernoPorIdState,
  (state: ObterArquivoCadernoPorIdState) => state
);

export const selectErrosObterArquivoCadernoPorId = createSelector(
    selectObterArquivoCadernoPorIdState,
    (state: ObterArquivoCadernoPorIdState) => state.error
);
